export default __webpack_public_path__ + "static/media/tich_hop_firm_bank_kr.afb08eb9.png";